import { ChevronDownIcon } from '@heroicons/react/24/outline';

interface VersionsBadgeProps {
    count: number;
    expanded: boolean;
}

// Every product shows the same "N version(s)" pill and expands the same way,
// single-version ones included - one workflow for the whole catalog.
export function VersionsBadge({ count, expanded }: VersionsBadgeProps) {
    return (
        <span
            className={`inline-flex items-center gap-2 text-[12px] font-medium px-2.5 py-1.5 rounded-lg border transition-colors ${
                expanded
                    ? 'border-gray-300 bg-gray-50 text-gray-900'
                    : 'border-gray-200 bg-white text-gray-700'
            }`}
        >
            {count} {count === 1 ? 'version' : 'versions'}
            <ChevronDownIcon
                className={`h-3.5 w-3.5 text-gray-400 transition-transform ${expanded ? 'rotate-180' : ''}`}
            />
        </span>
    );
}
